export const resourseUrl = 'https://nanan.obs.cn-fz1.ctyun.cn/'